import { render } from "./vmemberswitchset.vue?vue&type=template&id=3ff1c2a8&scoped=true"
import script from "./vmemberswitchset.vue?vue&type=script&lang=js"
export * from "./vmemberswitchset.vue?vue&type=script&lang=js"

import "./vmemberswitchset.vue?vue&type=style&index=0&id=3ff1c2a8&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff1c2a8"]])

export default __exports__